export default __webpack_public_path__ + "static/media/frontpage2.4559296a.txt";